<template src="./template.html" />

<script>
/* eslint-disable */
import LandingPages from 'src/modules/pages/landing-page'
import { canInCollection } from 'naf-acl'
const DEFAULT_FILTER = {
  "compositeFilter" : {
    "op": "AND",
    "filters": [{
        "fieldFilter": {
        "field": {"fieldPath": "supplier.id"}, 
        "op":"EQUAL", 
        "value": {"stringValue": "DTYCjt67rOVWBH8WCSaK@0"}
        }
      }]
    }
    
  }
const DEFAULT_ORDER = ['metaData.lastModifiedTime', 'desc']
const axios = require('axios')
import FireStoreParser from 'firestore-parser'
import { mapGetters } from 'vuex'
export default {
  name: 'ManageOrder',
  components: {
    LandingPages
  },
  data () {
    return {
      baseData: null,
      DEFAULT_FILTER: DEFAULT_FILTER,
      DEFAULT_ORDER: DEFAULT_ORDER,
      dep: 'TB',
      isLoading: false,
      tableConfig: {
      isLoading: false,
        hideBottom: true,
        pagination: {
          'rowsPerPage': !this.$q.screen.gt.xs ? 10 : 20,
          'rowsNumber': 50,
          'descending': true,
          'sortBy': 'metaData.lastModifiedTime'
        }
      },
      pickPaths: ['department', 'noContract', 'salesOwner', 'customer', 'primaryOrderCode', 'subOrderCode',
        'deliveryLocation', 'deliveryCondition', 'deliveryStartTime', 'deliveryEndTime', 'wareHouse', 'paymentPolicyNoDay',
        'paymentPolicyAfterDay', 'unitMoney', 'exchangeRate', 'paymentMethod', 'orderNote', 'productList'],
      headers: [
        {
          label: 'No',
          align: 'left',
          sortable: false,
          name: 'no'
        },
        {
          label: 'Khách hàng',
          align: 'left',
          name: 'customer',
          field: 'customer',
          sortable: true,
          labelFormat: `$this.shortName + ' - ' + $this.name`
        },
        {
          label: 'Mã đơn hàng',
          align: 'center',
          name: 'primaryOrderCode',
          field: 'primaryOrderCode',
          labelFormat: `$this + '' + (row.subOrderCode ? '/' : '') + (row.subOrderCode ? row.subOrderCode : '')`,
          sortable: true,
          sort: (a, b) => a.name.localeCompare(b.name)
        },
        {
          label: 'Mã hợp đồng',
          align: 'center',
          name: 'noContract',
          field: 'noContract',
          sortable: true,
          sort: (a, b) => a.name.localeCompare(b.name)
        },
        {
          label: 'Sản phẩm',
          align: 'left',
          name: 'productList',
          field: 'productList',
          labelFormat: '$this.name',
          uniqueBy: 'name'
        },
        {
          label: 'Tổng tiền',
          align: 'center',
          name: 'totalMoney',
          field: 'totalMoney',
          labelFormat: 'NumberUtils.thousandSeprator($this)'
        },
        {
          label: 'Loại tiền tệ',
          align: 'center',
          name: 'unitMoney',
          field: 'unitMoney'
        },
        {
          label: 'Nơi giao hàng',
          align: 'center',
          name: 'deliveryLocation',
          field: 'deliveryLocation'
        },
        {
          label: 'Thời gian giao hàng',
          align: 'center',
          name: 'deliveryStartTime',
          field: 'deliveryStartTime',
          labelFormat: 'moment($this).format("DD/MM/YYYY") + " - " +moment(row.deliveryEndTim).format("DD/MM/YYYY")',
          // labelFormat: '($this && $this instanceof Timestamp  ? $this.toDate().getDate() + \'/\' + ($this.toDate().getMonth() + 1) + \'/\' + $this.toDate().getFullYear() : \'\') ' +
          // ' + (row.deliveryEndTime && row.deliveryEndTime instanceof Timestamp && !this._.isEqual($this, row.deliveryEndTime)  ? \' - \' + row.deliveryEndTime.toDate().getDate() + \'/\' + (row.deliveryEndTime.toDate().getMonth() + 1) + \'/\' + row.deliveryEndTime.toDate().getFullYear() : \'\')',
          sortable: true
        },
        {
          label: 'Trạng thái đơn hàng',
          align: 'center',
          name: 'orderStatus',
          field: 'orderStatus',
          type: 'Label',
          sortable: true,
          sort: (a, b) => a.name.localeCompare(b.name),
          config: {
            format: 'this.value.name',
            chipMode: true,
            colorChip: 'this.value.color',
            watch: true
          }
        }
      ],
      entitySelector: {
        customer: {
          config: {
            datasource: {
              options: [],
              label: 'name',
              field: 'byName',
              value: 'id',
              emitValue: true,
            },
            fieldName: 'nothing',
            label: 'Khách hàng',
            useInput: true,
            sortBy: 'name',
            isLoading: true,
            icon: 'accessibility',
            mapOptions: true,
            clearable: true
          },
          data: null,
          chipModel: null,
          chipShow: false,
          query: ['Customer', 'index']
        },
        product: {
          config: {
            datasource: {
              options: [],
              label: 'name',
              value: 'id',
              emitValue: true,
              // filterFn: (item) => item.saleDep === 'TB'
            },
            fieldName: 'nothing',
            mapOptions: true,
            sortBy: 'name',
            label: 'Sản phẩm',
            useInput: true,
            icon: 'fas fa-lemon',
            clearable: true
          },
          data: null,
          chipModel: null,
          chipShow: false,
          query: ['MasterData', 'Product']
        },
        noContract: {
          config: {
            label: 'Mã hợp đồng',
            icon: 'business',
            clearable: true
          },
          fieldName: 'nothing',
          data: null,
          chipModel: null,
          chipShow: false
        },
        primaryOrderCode: {
          config: {
            label: 'Mã đơn hàng',
            icon: 'receipt',
            fieldName: 'nothing'
          },
          data: null,
          chipModel: null,
          chipShow: false
        },
        declarDate: {
          data: null,
          config: {
            label: 'Tháng mở tờ khai',
            defaultMonth: null
          },
          chipModel: null,
          chipShow: false
        }  
      },
      landingPagesConfig: {
        isLoading: false,
        backLink: '/',
        routeDetailName: '/manage-order/order-detail',
        canCreate: false,
        canCopy: false
      },
      queryConditions: {},
      filterDialog: false,
      downloading: false,
      orderUrl: null,
    }
  },
  async created() {
    try {
      if (this.hasPerm()) {
        await this.auth()
        this.search()
        // this.recoverFilter()
        this.fetchProduct()
        this.fetchCustomer()
      }
      else {
        throw new Error("No permission")
      }
    }
    catch (e) {
      this.$q.notify({
          message: `${e}`,
          color: 'red',
          icon: 'check'
        })
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'permission',
      'isAnonymous',
      'namisInfo'
    ]),
  },
  methods: {
    recoverFilter() {
      if(!this._.isEmpty(this.$store.getters.orderState.filter[this.dep])){
        this.entitySelector = this.R.mergeDeepRight(this.entitySelector, this.$store.getters.orderState.filter[this.dep])
        this.search()
      }
    },
    async handlerDetail (id) {
      let vm = this
      let dataFetched = await this.$query(['Orders', id])
      this.$router.push({
        name: vm.landingPagesConfig.routeDetailName,
        query: {
          id: id
        },
        params: {
          orderId: id,
          mode: 'EDIT',
          department: this.deparment,
          data: dataFetched
        }
      })
    },
    async handlerCopy (id) {
      let vm = this
      let dataFetched = await vm.$query(['Orders', id])
      this.$router.push({
        name: vm.landingPagesConfig.routeDetailName,
        params: {
          mode: 'COPY',
          data: vm._.pick(dataFetched, vm.pickPaths)
        }
      })
    },
    async handlerDelete (payload, resolve, reject) {
      let vm = this
      let submitModel = { id: payload._id, data: vm._.omit(payload, '_id', '__index') }
      await vm.$command.execute('deleteOrder', submitModel).then(() => resolve('resolved')).catch(err => reject(err))
    },
    handlerAddButtonClick () {
      let vm = this
      vm.$router.push({ name: vm.landingPagesConfig.routeDetailName, params: { mode: 'CREATE' } })
    },
    canInCollection,
    search() {
      this.buildChip()
      this.searchBuilder()
      this.filterDialog = false
      let orderState = { filter: {}}
      if(this.hasPerm()) this.queryNamisOrder()
    },
    removeChip(item) {
      item.data = null
      item.chipModel = null
      this.search()
    },
    buildChip() {
      this.entitySelector.customer.chipModel = this.entitySelector.customer.chipModel ? this.entitySelector.customer.chipModel : this._.cloneDeep(this._.get(this.$refs, ['customer', 'innerValue', '0', 'name']))
      this.entitySelector.customer.chipShow = !this._.isNil(this.entitySelector.customer.chipModel)
      this.entitySelector.product.chipModel = this.entitySelector.product.chipModel ? this.entitySelector.product.chipModel : this._.cloneDeep(this._.get(this.$refs, ['product', 'innerValue', '0', 'name']))
      this.entitySelector.product.chipShow = !this._.isNil(this.entitySelector.product.chipModel)
      this.entitySelector.noContract.chipModel = this.entitySelector.noContract.chipModel ? this.entitySelector.noContract.chipModel : this.entitySelector.noContract.data
      this.entitySelector.noContract.chipShow = !this._.isNil(this.entitySelector.noContract.chipModel)
      this.entitySelector.primaryOrderCode.chipModel = this.entitySelector.primaryOrderCode.chipModel ? this.entitySelector.primaryOrderCode.chipModel : this.entitySelector.primaryOrderCode.data
      this.entitySelector.primaryOrderCode.chipShow = !this._.isNil(this.entitySelector.primaryOrderCode.chipModel)
      this.entitySelector.declarDate.chipModel = this.entitySelector.declarDate.chipModel ? this.entitySelector.declarDate.chipModel : this.entitySelector.declarDate.data
      this.entitySelector.declarDate.chipShow = !this._.isNil(this.entitySelector.declarDate.chipModel)
    },
    searchBuilder() {
      let fieldFilter = {
          "fieldFilter": {
            "field": {
              "fieldPath": ""
            },
            "op": 'EQUAL',
            "value": {}
          }
        }
      this.queryConditions.filter = this._.cloneDeep(this.DEFAULT_FILTER)
      // this.queryConditions.order = this.DEFAULT_ORDER
      let customerData = this.R.path(['customer', 'data'], this.entitySelector)
      if(customerData) {
        let filter = this._.cloneDeep(fieldFilter)
        filter.fieldFilter.field.fieldPath = "customer.id"
        filter.fieldFilter.value = {"stringValue": customerData}
        this.queryConditions.filter.compositeFilter.filters.push(filter)
      }
      let declarDate = this.R.path(['declarDate', 'data'], this.entitySelector)
      if(declarDate) {
        let filter = this._.cloneDeep(fieldFilter)
        filter.fieldFilter.field.fieldPath = "metaData.search.declarOrExwDate"
        filter.fieldFilter.value = {"stringValue": declarDate}
        this.queryConditions.filter.compositeFilter.filters.push(filter)
      }
      let product = this.R.path(['product', 'data'], this.entitySelector)
      if(product) {
        let filter = this._.cloneDeep(fieldFilter)
        filter.fieldFilter.field.fieldPath = "metaData.products"
        filter.fieldFilter.value = {"stringValue": product}
        filter.fieldFilter.op = 'ARRAY_CONTAINS'
        this.queryConditions.filter.compositeFilter.filters.push(filter)
      }
      let noContract = this.R.path(['noContract', 'data'], this.entitySelector)
      if(noContract) {
        let filter = this._.cloneDeep(fieldFilter)
        filter.fieldFilter.field.fieldPath = "metaData.search.noContract"
        filter.fieldFilter.value = {"stringValue": this.removeAccents(noContract)}
        this.queryConditions.filter.compositeFilter.filters.push(filter)
      }
      let primaryOrderCode = this.R.path(['primaryOrderCode', 'data'], this.entitySelector)
      if(primaryOrderCode) {
        let filter = this._.cloneDeep(fieldFilter)
        filter.fieldFilter.field.fieldPath = "metaData.search.primaryOrderCode"
        filter.fieldFilter.value = {"stringValue": this.removeAccents(`${primaryOrderCode}`)}
        this.queryConditions.filter.compositeFilter.filters.push(filter)
      }
    },
    fetchCustomer() {
      let body = {
        url: `https://firestore.googleapis.com/v1/projects/${this.namisInfo.projectId}/databases/(default)/documents/Customer/index`,
        method: 'get',
        headers: {
          'Content-Type':'application/json',
          'Authorization': `Bearer ${this.namisInfo.idToken}`
        }
      }
      axios(body).then(res => {
        if (res.data && res.data.fields) {
          this.entitySelector.customer.config.datasource.options = FireStoreParser(res.data).fields.byName
          this.entitySelector.customer.config.isLoading = false
        }
      }).catch(e => {
        this.entitySelector.customer.config.isLoading = false
      })
    },
    clearFilter() {
      this.filterDialog = false
      this.$nextTick(() => {
        for(let key in this.entitySelector) {
          this.entitySelector[key].data = null
          this.entitySelector[key].chipModel = null
          this.entitySelector[key].chipShow = false
        }
        this.search()
      })
    },
    fetchProduct() {
      let body = {
        url: `https://firestore.googleapis.com/v1/projects/${this.namisInfo.projectId}/databases/(default)/documents/MasterData/Product`,
        method: 'get',
        headers: {
          'Content-Type':'application/json',
          'Authorization': `Bearer ${this.namisInfo.idToken}`
        }
      }
      axios(body).then(res => {
        if (res.data && res.data.fields) {
          this.entitySelector.product.config.datasource.options = FireStoreParser(res.data).fields.list
          this.entitySelector.product.config.isLoading = false
        }
      }).catch(e => {
        this.entitySelector.customer.config.isLoading = false
      })
      
    },
    removeAccents(str) {
      return str.toLowerCase().normalize('NFD')
        .replace(/\s+/g, '')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[\u0020-\u002f]/g, '')
        .replace(/[\u003a-\u003f]/g, '')
        .replace(/[\u0040]/g, '')
        .replace(/[\u0060]/g, '')
        .replace(/[\u005b-\u005f]/g, '')
        .replace(/[\u007b-\u007f]/g, '')
        .replace(/[\u0080-\u00bf]/g, '')
        .replace(/đ/g, 'd').replace(/Đ/g, 'D');
    },
    hasPerm() {
      let accept = ['BOM']
      let roles = this._.intersection(accept, Object.keys(this.permission.roles))
      return roles.length > 0
    },
    async auth() {
      if (!this.namisInfo) {
        let info = await this.$query(['Users','namis'])
        if (!info.tokenId) {
          await axios.post(`https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${info.apiKey}`,{
            email: info.email,
            password:info.password,
            returnSecureToken: true
          }).then(res => {
            let innerInfo = info
            innerInfo.idToken = res.data.idToken
            this.$store.dispatch('registerNamisInfo',innerInfo)
          })
        } else this.$store.dispatch('registerNamisInfo',innerInfo)
        
      } 
    },
    async queryNamisOrder() {
      let defaultFilter = 
      {
        "fieldFilter": {
          "field": {"fieldPath": "supplier.id"}, 
          "op":"EQUAL", 
          "value": {"stringValue": "DTYCjt67rOVWBH8WCSaK@0"}
        },
      }
      let body = {
        url: `https://firestore.googleapis.com/v1/projects/${this.namisInfo.projectId}/databases/(default)/documents:runQuery`,
        method: 'post',
        data: {
          "structuredQuery": {
              "from": [
                  {
                    "collectionId": "Orders"
                  }
            ],
            "where": {
              
            },
            "orderBy": [
              {
                "field": {"fieldPath": "metaData.lastModifiedTime"},
                "direction": "DESCENDING"
              }
            ],
            "limit": 20
          }
          },
        headers: {
          'Content-Type':'application/json',
          'Authorization': `Bearer ${this.namisInfo.idToken}`
        }
      }
      body.data.structuredQuery.where = this.queryConditions.filter
      axios(body).then( res => {
        if (res.data) {
          let parse = FireStoreParser(res.data).filter(item => item.document)
          this.baseData = parse.map(item => {
            if (item.document)
            {
              let field = item.document.fields
              let name = item.document.name.split('/')
              field._id = name[name.length-1]
              return field
            }
          })
          this.tableConfig.hideBottom = !this._.isEmpty(this.baseData)
        }
      })
    },
    async downloadOrder() {
      let url
      try {
        if (!this.namisInfo || !this.hasPerm()) {
          throw Error("No permission")
        }
        let vm = this
        this.downloading = true
        let a = document.createElement("a")
        document.body.appendChild(a)
        a.href = await vm.$storage.ref('/manageOrder/baocaochuoi.xlsx').getDownloadURL()
        a.download = `baocaochuoi.xlsx`
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      }
      catch (err) {
        this.$q.notify({
          message: 'Error: ' + err.message,
          color: 'red',
          icon: 'error'
        })
      }
      this.downloading = false
    }
  }
}
</script>
